module.exports = __webpack_public_path__ + "static/media/icon-piece7-3.7037833a.png";